import { useRef, useState } from "react";
import qs from "qs";
import dataProvider from "../../../../../services/dataProvider";
import authServices from "../../../../../services/authServices";
import axios from "axios";

const MixedFileUploadButton = ({ setFile, file = {} ,field=""}) => {
    let fileInput = useRef();
    const [isLoading, setIsLoading] = useState(false);
    function handleClick() {
        fileInput.current.click();
    }

    function onFileView(fileName) {
        var data = qs.stringify({
            filePath: fileName ,
        });
        setIsLoading(true);
        var config = {
            method: "post",
            url: dataProvider.baseUrl + "getFileUrlFromFilePath",
            headers: {
                token: authServices.getToken(),
            },
            data: data,
        };

        axios(config)
            .then(function (response) {
                // console.log(response)
                setIsLoading(false);
                window.open(response.data.data[0], '_blank').focus();
            })
            .catch(function (error) {
                setIsLoading(false);
                console.error(error.message);
            });
    }

    return (
        <div className="w-100 d-flex align-items-center flex-nowrap border rounded p-2" style={{ overflow: "hidden" }}>
            <input
                ref={fileInput}
                onChange={(e) => {
                    if (e.target.files.length > 0) {
                        setFile(e.target.files[0],"",false,field);
                    } else {
                        setFile(null,"",false,field);
                    }
                }}
                style={{
                    position:"absolute",
                    pointerEvents:"none",
                    opacity:0
                }}
                type="file"
                required={!file.isLink}
            />

            {file.isLink === true ? (
                <div className="flex-fill position-relative" onClick={()=>onFileView(file.link)}>
                    <div
                        className="btn p-0 w-100 ms-2 text-start flex-fill border-0 text-primary text-decoration-underline text-nowrap"
                        style={{ overflow: "hidden", maxWidth: "20ch", textOverflow: "ellipsis" }}
                    >
                        {file.name}
                    </div>
                    {
                        isLoading && (
                            <div className="position-absolute top-50 end-0 translate-middle">
                                <div className="spinner-border spinner-border-sm text-primary" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </div>
                            
                        )
                    }
                </div>
            ) : (
                <div className="flex-fill">
                    {file.name ? (
                        <div
                            className="btn p-0 w-100 ms-2 text-start flex-fill border-0 text-primary text-nowrap"
                            style={{ overflow: "hidden", maxWidth: "20ch", textOverflow: "ellipsis" }}
                        >
                            {file.name}
                        </div>
                    ) : (
                        <div
                            className="btn p-0 w-100 ms-2 text-start flex-fill border-0 text-black-50 text-nowrap"
                            style={{ overflow: "hidden", maxWidth: "20ch", textOverflow: "ellipsis" }}
                        >
                            Choose File
                        </div>
                    )}
                </div>
            )}

            <div
                onClick={handleClick}
                className="btn btn-primary text-start text-light border-0 p-1 px-2 d-flex align-items-center justify-content-center"
            >
                {file.isLink ? "Change" : "Upload"}
            </div>
        </div>
    );
};

export default MixedFileUploadButton;
